import {
    GET_MERCHANT_PAYMENT_CONFIG_FAILED,
    GET_MERCHANT_PAYMENT_CONFIG_LOADING,
    GET_MERCHANT_PAYMENT_CONFIG_SUCCESS,
    REMOVE_MERCHANT_PAYMENT_CONFIG
} from "../types";

const initialState = {
    loading: false,
    error: null,
    PaymentConfig: null,
};

export const getPaymentConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_PAYMENT_CONFIG_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_PAYMENT_CONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                PaymentConfig: action.payload,
                error: null,
            };
        case GET_MERCHANT_PAYMENT_CONFIG_FAILED:
            return {
                ...state,
                loading: false,
                PaymentConfig: null,
                error: action.error,
            };
        case REMOVE_MERCHANT_PAYMENT_CONFIG:
            return initialState;
        default:
            return state;
    }
};
